export default __webpack_public_path__ + "static/media/logo-nav.c19e1d10.png";